import { LAYER_STYLE } from '../../../../core/dom';
import { UI_LAYER } from '../../../theme/constants';

export const wrapperStyle = { height: '100%' };
export const style = {
  ...LAYER_STYLE,
  zIndex: UI_LAYER,
  overflow: 'hidden'
};
